import React from "react"
import SocialShareButtons from "@bufox/dry-social-share-buttons"
import styled from "styled-components"

const ThemeSocialShareButtons = styled(SocialShareButtons)`
  .share-link {
    background-color: var(--secondary);
    &:hover {
      background: var(--tertiary);
    }
  }
`

export default ThemeSocialShareButtons
